import { FieldValues, FormState } from 'react-hook-form';
import { Banner } from '@optimus-web/core';
import { FormInputField, FormTextareaField, LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { FIELD_NAMES } from '../types/Form';
import { WithEnterpriseIds } from '../../../../enterpriseRateManagement/types';

type Props = Partial<WithEnterpriseIds> & { formState: FormState<FieldValues> };

export const PropertyGroupDetailsFields = ({ enterpriseIds, formState }: Props) => (
    <>
        {enterpriseIds && enterpriseIds.length > 1 && (
            <Banner
                variant="info"
                primaryText={<LocalizedText textKey={TextKey.PropertyAddGroupBanner} />}
                secondaryText={
                    <LocalizedText
                        textKey={TextKey.PropertyGroupSelectedPropertiesCountMessage}
                        substitutes={{ numberOfProperties: enterpriseIds.length }}
                    />
                }
            />
        )}
        <FormInputField
            required
            size="large"
            name={FIELD_NAMES.NAME}
            helper={
                !formState.errors[FIELD_NAMES.NAME] && (
                    <LocalizedText textKey={TextKey.MaximumCharacterLengthShortInput} />
                )
            }
            label={<LocalizedText textKey={TextKey.PropertyAddGroupNameField} />}
        />
        <FormTextareaField
            size="large"
            name={FIELD_NAMES.DESCRIPTION}
            label={<LocalizedText textKey={TextKey.Description} />}
        />
    </>
);
